import { Dispatch } from 'redux';
import { updateIsLoadingDashboardData } from '../slices/dashboard.slice';

export const updateIsLoadingDashboard = (isLoading: boolean) => async (dispatch: Dispatch) => {
	dispatch(updateIsLoadingDashboardData({ isLoadingDashboardData: isLoading }));
};
